<template>

  <div class="linkus">
    <div class="l-main" ref="contactSection">
      <div class="link-title">
        <h1>{{isEnglish ? 'Contact Us' : '联系我们'}}</h1>

      </div>
      
    <div class="put">
      <el-form :model="form" :rules="rules" ref="formRef" class="sum-form">
        <!-- 咨询 -->
      <el-form-item :label="isEnglish ? 'Selection:' : '咨询类型:'" prop="resource">
        <el-radio-group v-model="form.messageType">
          <el-radio :value='1'>{{ isEnglish ? 'Product Consulting' : '产品咨询' }}</el-radio>
          <el-radio :value='2'>{{ isEnglish ? 'Eco-cooperation' : '生态合作' }}</el-radio>
          <el-radio :value='3'>{{ isEnglish ? 'Media Cooperation' : '媒体合作' }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <div class="line-form">
      <!-- 年龄 -->
      <el-form-item :label="isEnglish ? 'Name:' : '姓名:'" prop="name" style="width: 48%;">
          <el-input v-model="form.name"></el-input>
      </el-form-item>
      <!-- 邮箱 -->
      <el-form-item :label="isEnglish ? 'Email:' : '电话:'" prop="email" style="width: 48%;">
          <el-input v-model="form.email"></el-input>
      </el-form-item>
      </div>
      <!-- 公司名称 -->
      <el-form-item :label="isEnglish ? 'Company:' : '公司名称:'" prop="company">

          <el-input v-model="form.company"></el-input>
      </el-form-item>
      <div class="foot-form">

        <!-- 留言内容 -->
       <el-form-item :label="isEnglish ? 'Content:' : '留言内容:'" prop="content" style="width: 91%;">

          <el-input v-model="form.content" type="textarea" :row="4" resize="none" show-word-limit maxlength="500"/>
      </el-form-item>
      <!-- 按钮 -->
      <el-form-item>
      <el-button @click="submitForm">{{ isEnglish ? 'Sumbit' : '提交' }}</el-button>

      </el-form-item>
      </div>
     
      </el-form>
    </div>
    </div>
    
  </div>
</template>
<script setup name="LinkUs">

import { ref, reactive } from 'vue';
import { computed,onMounted } from 'vue';
const formRef = ref(null);

const isEnglish = computed(() => {
  return window.location.pathname.startsWith('/en')
})
const form = reactive({
  appId: 2,
  objectType: 'contact',
  name: '',
  messageType: 1,
  email: '',
  company: '',
  content: '',
  MessageTime: getFormattedTime(),
});
const rules = reactive({
  name: [
    { required: true, message:isEnglish.value?'Please input your name':'请输入您的姓名', trigger: "blur" },
    { min: 2, max: 5, message: isEnglish.value?'Length should be 2 to 5':'姓名长度为2到5个字符', trigger: "blur" }
  ],
  email: [
    { required: true, message: isEnglish.value?'Please input the email':'请输入电话', trigger: "blur" },
    { type:isEnglish.value? "email":'', message: isEnglish.value?'Please input the correct email':'', trigger: "blur" }
  ],
  messageType: [
    { required: true, message: isEnglish.value?'Please select an option':'请选择咨询类型', trigger: "change" }
  ],company: [
    { required: true, message: isEnglish.value?'Please input the company':'请输入公司名称', trigger: "blur" },
    { min: 1, max: 10, message: isEnglish.value?'Length should be 1 to 10':'公司名称长度为1到10个字符', trigger: "blur" }
  ],content: [
    { required: true, message: isEnglish.value?'Please input the desc':'请输入留言内容', trigger: "blur" }
  ]
});
onMounted(() => {
  console.log('组件挂载成功');
  console.log('form', form);
});
// const submit = () => {
//   if (!formRef.value) return;
//   formRef.value.validate((valid) => {
//     if (valid) {
//       alert("Submit success!");
//     } else {
//       alert("Sumbit failure");
//     }
//   });
// };
import { linkus } from '@/api/linkadd';
import { ElMessage } from 'element-plus';
// 提交表单
const submitForm = async () => {
  try {
    const valid=await formRef.value.validate();
    if (valid) {
    console.log('表单值：',form)
      const response = await linkus(form);
    console.log(response)
     ElMessage.success(isEnglish.value?'Submit success':'提交成功');

    // 提交成功后重置表单
    formRef.value.resetFields()
  }
  }catch(error){
    ElMessage.error(isEnglish.value?'Submit failed':'提交失败');

  }
};
// 点击按钮跳转带组件所在位置
const contactSection = ref(null)

function getFormattedTime() {
  const now = new Date();
  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const dd = String(now.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}
function scrollToMe() {
  contactSection.value?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  })
}
function setResourceType(type) {
  console.log(type) 
  form.messageType = type; 
}
// 暴露给父组件
defineExpose({ 
  scrollToMe,
  setResourceType
});
</script>

<style scoped>
.linkus{
  width:60%;
  margin: 10em auto;
  height: 400px;
}
.l-main{
  width: 100%;
}
.link-title{
  width: 100%;
  text-align: center;
}
.link-title p{
  margin: 1em auto;
  text-align: center;
}
.put{
  width: 100%;
  border:1px solid #ddd;
  margin-top: 2em;
}
.sum-form{
  width: 80%;
  margin: 5em auto;
}
.line-form{
  display: flex;
  justify-content: space-between;
}
/* :deep(.el-form-item__label) {
  display: inline-block;
  width: 16%;
  text-align: left !important;
} */
:deep(.el-form-item) {
  display: flex !important;
  align-items: center !important;
  margin-bottom: 22px !important;
}

:deep(.el-form-item__content) {
  flex: 1 !important;
  display: flex !important;
  align-items: center !important;
}

:deep(.el-form-item__label) {
  width: 120px !important;
  text-align: left !important;
  justify-content: flex-start!important;
  padding-right: 12px !important;
  flex-shrink: 0 !important;
}

:deep(.el-input),
:deep(.el-textarea) {
  flex: 1 !important;
}
.foot-form{
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.el-button{
  width: 100px;
  height: 4.5em;
  background-color: rgb(209, 52, 52);
  color: #fff;
}
:deep(.el-textarea__inner) {
    width: 100%;
    min-height: 4.5em !important;
}
@media (max-width: 1024px) {
  .link-title>h1{
    font-size: 1.2em;
  }
  .link-title>p{
    font-size: 0.8em;
  }
  .linkus {
    width: 90%; 
    margin: 5em auto;
    height: auto; 
  }
  .sum-form {
    width: 90%; 
    margin: 2em auto; 
  }
  .line-form {
    flex-direction: column; 
  }
  .line-form .el-form-item {
    width: 100% !important; 
  }
  :deep(.el-form-item__label) {
  display: inline-block;
  width: 22%;
  font-size:0.5em;
  text-align: left !important;
}
  .foot-form {
    flex-direction: column;
  }
  .foot-form .el-form-item {
    width: 100% !important; 
  }
 .el-button {
    width: 20%;
    height: 2.5em;
    margin:0 auto;
    font-size: 0.8em;
  }
}
</style>
